export type DeleteMotiveErrorCode = 'PERMISSION_DENIED' | 'UNKNOWN';

export class DeleteMotiveError extends Error {
    code: DeleteMotiveErrorCode;

    constructor(code: DeleteMotiveErrorCode, message: string) {
        super(message);
        this.code = code;
    }
}
